module.exports = "/images/loading-spinner.png";